export interface P2pMessage {
  userId: string;
  type: P2pDataType;
  content?: string;
  name?: string;
}

export enum P2pDataType {
  chat = 'CHAT',
  system = 'SYSTEM',
  nameChange = 'NAME_CHANGE',
}

export enum P2pSystemMsg {
  requestAccess = 'REQUEST_ACCESS',
  confirmAccess = 'CONFIRM_ACCESS',
  denyAccess = 'DENY_ACCESS',
  ownAudioOn = 'OWN_AUDIO_ON',
  ownAudioOff = 'OWN_AUDIO_OFF',
  audioOff = 'AUDIO_OFF',
  ownVideoOn = 'OWN_VIDEO_ON',
  ownVideoOff = 'OWN_VIDEO_OFF',
  videoOff = 'VIDEO_OFF',
  hangUp = 'HANG_UP',
  focus = 'FOCUS',
  focusEnd = 'FOCUS_END',
}

export interface CallMetaData {
  audioEnabled: boolean;
  videoEnabled: boolean;
  displayName?: string;
}

export interface SpeakingEvent {
  userId: string;
  active: boolean;
}
